const impactPath = 'impactOnPatients.';

const impactTrans = {
    ACUITY_TITLE: impactPath + 'visualAcuityTitle',
    ACUITY_DESCRIPTION: impactPath + 'acuityDescription',
    FUNCTIONAL_GA_TITLE: impactPath + 'functionalGATitle',
    GA_CHANGES_TITLE: impactPath + 'gaChangesLife',

    GA_CHANGES_DESCRIPTION: impactPath + 'gaChangesDescription',
    GA_CHANGES_SUB_TITLE: impactPath + 'gaChangesSubTitle'
}

export default impactTrans